import NomenclatureListPage from "../../../common/nomenclatures/NomenclatureListPage";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import {
  baseNomenclatureDefaults,
  baseNomenclatureSchema,
  IBaseNomenclatureInputModel,
} from "../../../common/nomenclatures/models/baseNomenclatureInputModel";
import { DefaultInputField } from "../../../common/components/forms/inputs/InputField/DefaultInputField";
import { nameof } from "ts-simple-nameof";
import { NomenclatureListPageBaseItem } from "../../../common/nomenclatures/components/NomenclatureListPageBaseItem";

export const StudioHallTypesNomenclature = () => {
  return (
    <NomenclatureListPage<
      IBaseNomenclatureInputModel,
      IBaseNomenclatureInputModel
    >
      endpoints={endpointsMetadata.studioHallTypeNomenclature}
      title={"Зали"}
      dialogAddTitle="Добавяне на нова зала"
      dialogEditTitle="Редактиране на зала"
      emptyListText={"В момента нямате добавени зали"}
      itemTemplate={(item, index, isLoading, actionButtons, className) => (
        <NomenclatureListPageBaseItem
          item={item}
          isLoading={isLoading}
          actionButtons={actionButtons}
          className={className}
        />
      )}
      formSchema={baseNomenclatureSchema}
      defaultValues={() => baseNomenclatureDefaults}
      formFields={
        <DefaultInputField
          name={nameof<IBaseNomenclatureInputModel>((x) => x.name)}
          label="Име на зала"
          placeholder={"Зала 1"}
        />
      }
      editOnRowClick
      deletedFilter={{
        storageKey: "studioHallTypes",
        sectionTitle: "Изтрити зали",
        toggleLabel: "Покажи изтритите зали",
      }}
    />
  );
};
